<div class="w-full h-full">
  <!-- Título do gráfico (se fornecido) -->
  <h3 *ngIf="title" class="text-lg font-semibold mb-4 text-center">{{ title }}</h3>
  
  <!-- Container do gráfico -->
  <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-between gap-6 h-full">
    <!-- Gráfico circular -->
    <div class="relative w-48 h-48 lg:w-40 lg:h-40 flex-shrink-0">
      <!-- Círculo base -->
      <div class="w-full h-full rounded-full bg-gray-100"></div>
      
      <!-- Gráfico de pizza com caminho SVG -->
      <svg class="absolute top-0 left-0 w-full h-full" viewBox="0 0 100 100">
        <!-- Segmentos do gráfico de pizza -->
        <ng-container *ngIf="total > 0">
          <path 
            *ngFor="let segment of pieSegments; let i = index"
            [attr.d]="segment.path"
            [attr.fill]="segment.strokeColor"
            [style.animation]="animated ? 'expandSegment 0.5s ease-out forwards' : 'none'"
            [style.animation-delay]="animated ? (i * 0.1) + 's' : '0s'"
          ></path>
        </ng-container>
      </svg>
      
      <!-- Total no centro -->
      <div *ngIf="showTotal && total > 0" 
           class="absolute inset-0 flex items-center justify-center flex-col text-white">
        <span class="text-lg font-bold">{{ formatValue(total) }}</span>
        <span class="text-xs">Total</span>
      </div>
    </div>
    
    <!-- Legenda -->
    <div *ngIf="showLegend && pieSegments.length > 0" 
         class="flex-1 w-full lg:max-w-none">
      <div class="grid grid-cols-1 gap-2 max-h-80 overflow-y-auto">
        <div *ngFor="let segment of pieSegments" class="flex items-center justify-between p-2 bg-gray-50 rounded-md">
          <div class="flex items-center flex-1 min-w-0">
            <div [style.background-color]="segment.strokeColor" class="w-3 h-3 mr-3 rounded-sm flex-shrink-0"></div>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-900 truncate" [title]="segment.name">
                {{ segment.name }}
              </div>
              <div class="text-xs text-gray-500">
                {{ formatValue(segment.value) }} unidades
              </div>
            </div>
          </div>
          <div class="ml-3 flex-shrink-0">
            <span class="text-sm font-bold text-gray-900">{{ formatPercentage(segment.value) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 